/**
 * Global event bus to open the "Talk to us now" modal from anywhere in the
 * app. A single <CallMeNowModal /> mounted at the root listens for this
 * event and renders the branded form + hidden Close webform.
 */
export type CallMeNowSource =
  | "nav_desktop"
  | "nav_mobile"
  | "hero"
  | "savings_modal"
  | "roi_inline"
  | "cobrain_nav_desktop"
  | "cobrain_nav_mobile"
  | "cobrain_footer"
  | "cobrain_reserve_success"
  | string;

export const CALL_ME_NOW_EVENT = "electricsheep:open-call-me-now";

export function openCallMeNow(source: CallMeNowSource = "unknown") {
  if (typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent(CALL_ME_NOW_EVENT, { detail: { source } }),
  );
}